import React, { useEffect, useState } from 'react';
import { Button, Popover, Space } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import BotonDescargarArchivos from './BotonDescargarArchivos';
import BotonVerArchivos from './BotonVerArchivos';

export default function MenuAcciones({
  record,
  openedRecord,
  setOpenedRecord,
}) {
  const [opened, setOpened] = useState(false);
  const [modalContratosVisible, setModalContratosVisible] = useState(false);
  const [modalAnexosVisible, setModalAnexosVisible] = useState(false);
  const [modalDocumentosVisible, setModalDocumentosVisible] = useState(false);

  useEffect(() => {
    if (
      openedRecord &&
      !modalContratosVisible &&
      !modalAnexosVisible &&
      !modalDocumentosVisible &&
      openedRecord?.correo === record?.correo &&
      openedRecord.idOferta === record.idOferta
    ) {
      setOpened(true);
    } else if (opened === true) {
      setOpened(false);
    }
    // eslint-disable-next-line
  }, [
    openedRecord,
    modalContratosVisible,
    modalDocumentosVisible,
    modalAnexosVisible,
  ]);
  return (
    <Popover
      key={record.correo}
      content={
        <div>
          <Space size="middle" direction="vertical">
            <BotonDescargarArchivos
              record={record}
              keyId={record.correo}
              tipo="Contratos"
              solicitudNumero="trabajador"
            />
            <BotonDescargarArchivos
              record={record}
              keyId={record.correo}
              tipo="Documentos"
              solicitudNumero="trabajador"
            />
            <BotonVerArchivos
              record={record}
              keyId={record.correo}
              tipo="Contratos"
              visible={modalContratosVisible}
              setVisible={setModalContratosVisible}
            />
            {record?.tieneAnexos ? (
              <BotonVerArchivos
                record={record}
                keyId={record.correo}
                tipo="Anexos"
                visible={modalAnexosVisible}
                setVisible={setModalAnexosVisible}
              />
            ) : null}
            <BotonVerArchivos
              record={record}
              keyId={record.correo}
              tipo="Documentos"
              visible={modalDocumentosVisible}
              setVisible={setModalDocumentosVisible}
            />
            <Button
              type="primary"
              size="small"
              onClick={() => setOpenedRecord(null)}>
              Cerrar
            </Button>
          </Space>
        </div>
      }
      title="Acciones"
      trigger="click"
      open={opened}>
      <Button
        type="text"
        size="small"
        onClick={() => {
          if (opened) {
            setOpenedRecord(null);
          } else {
            setOpenedRecord(record);
          }
        }}>
        <MoreOutlined />
      </Button>
    </Popover>
  );
}
